import { localisedValue } from "utils"

export const projectCategoriesTransformer = data => {
  return data?.map(item => {
    return {
      value: item?.id?.toString(),
      label: localisedValue({ object: item, key: "name" }),
      key: item?.key,
    }
  })
}
